let api = 'https://api-dev.workstream.is';
let hr = 'https://hr-dev.workstream.us';

if (process.env.REACT_APP_DEPLOY_ENV === 'local') {
  hr = 'http://localhost:8000';
}

if (process.env.REACT_APP_DEPLOY_ENV === 'develop') {
  api = 'https://api-dev.workstream.is';
  hr = 'https://hr-dev.workstream.us';
}

if (process.env.REACT_APP_DEPLOY_ENV === 'staging') {
  api = 'https://api-staging.workstream.is';
  hr = 'https://hr-staging.workstream.us';
}

if (process.env.REACT_APP_DEPLOY_ENV === 'staging-1') {
  api = 'https://api-staging-1.workstream.is';
  hr = 'https://hr-staging-1.workstream.us';
}

if (process.env.REACT_APP_DEPLOY_ENV === 'production') {
  api = 'https://api.workstream.is';
  hr = 'https://hr.workstream.us';
}

export const APIHOST = api;
export const HRHOST = hr;
// TODO: Update base on new release date and keep consistent with HR project
export const SELF_SERVE_VERSION = '2020.08.26 Podding';
